{
  "name": "@tableau/mcp-server",
  "description": "Helping agents see and understand data.",
  "version": "4.8.1",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/tableau/tableau-mcp.git"
  },
  "homepage": "https://github.com/tableau/tableau-mcp",
  "bugs": "https://github.com/tableau/tableau-mcp/issues",
  "author": "Tableau",
  "type": "commonjs",
  "license": "Apache-2.0",
  "keywords": [
    "tableau",
    "mcp"
  ],
  "bin": {
    "tableau-mcp-server": "./build/index.js"
  },
  "exports": {
    ".": "./build/index.js",
    "./tracing": "./build/telemetry/tracing.js",
    "./features/featureGateProvider": {
      "types": "./build/features/featureGateProvider.d.ts"
    },
    "./telemetry/telemetryProvider": {
      "types": "./build/telemetry/telemetryProvider.d.ts"
    }
  },
  "scripts": {
    "build": "tsx src/scripts/build.ts && tsc --project tsconfig.providers.json",
    "build:desktop": "tsx src/scripts/build.ts --variant desktop && tsc --project tsconfig.providers.json",
    "build:combined": "tsx src/scripts/build.ts --variant combined && tsc --project tsconfig.providers.json",
    "build:dev": "tsx src/scripts/build.ts --dev && tsc --project tsconfig.providers.json",
    "build:docker": "docker build -t tableau-mcp .",
    ":build:mcpb": "npx -y @anthropic-ai/mcpb pack . tableau-mcp.mcpb",
    "build:mcpb": "run-s build:manifest :build:mcpb",
    "build:manifest": "tsx src/scripts/createClaudeMcpBundleManifest.ts",
    "start:http": "node build/index.js",
    "start:http:combined": "node build/index.combined.js",
    "start:http:apm": "node -r ./build/telemetry/tracing.js build/index.js",
    "start:http:docker": "docker run -p 3927:3927 -i --rm --env-file env.list tableau-mcp",
    "lint": "npm exec eslint",
    "lint:fix": "npm exec eslint -- --fix",
    "inspect": "npx @modelcontextprotocol/inspector --config config.json --server tableau",
    ":inspect:http": "npx @modelcontextprotocol/inspector --config config.http.json --server tableau",
    "inspect:http": "run-p start:http :inspect:http",
    "inspect:docker": "npx @modelcontextprotocol/inspector --config config.docker.json --server tableau",
    "inspect:docker:http": "run-p start:http:docker :inspect:http",
    "build:inspect": "run-s build inspect",
    "build:inspect:docker": "run-s build:docker inspect:docker",
    "build:inspect:docker:http": "run-s build:docker inspect:docker:http",
    "test": "vitest --config ./vitest.config.ts",
    "test:e2e": "vitest --config ./vitest.config.e2e.ts",
    "test:eval": "vitest --config ./vitest.config.eval.ts",
    "test:oauth:embedded": "vitest --config ./vitest.config.oauth.embedded.ts",
    "test:oauth:tableau": "npx playwright test",
    "coverage": "vitest run --config ./vitest.config.ts --coverage",
    "version:major": "npm version major --no-git-tag-version",
    "version:minor": "npm version minor --no-git-tag-version",
    "version:patch": "npm version patch --no-git-tag-version",
    "docs:start": "npm run start --prefix docs"
  },
  "dependencies": {
    "@aws-sdk/client-s3": "^3.1095.0",
    "@aws-sdk/s3-request-presigner": "^3.1095.0",
    "@mjackson/multipart-parser": "^0.10.1",
    "@modelcontextprotocol/ext-apps": "^1.7.2",
    "@modelcontextprotocol/sdk": "^1.26.0",
    "@xmldom/xmldom": "^0.9.10",
    "@zodios/core": "^10.9.6",
    "cookie-parser": "^1.4.7",
    "cors": "^2.8.5",
    "csv-parse": "^7.0.2",
    "dotenv": "^16.5.0",
    "express": "^5.1.0",
    "fast-levenshtein": "^3.0.0",
    "jose": "^6.0.12",
    "ssrfcheck": "^1.2.0",
    "ts-results-es": "^7.1.0",
    "uuid": "^14.0.1",
    "xpath": "^0.0.34",
    "zod": "^3.24.3",
    "zod-validation-error": "^4.0.1"
  },
  "devDependencies": {
    "@anthropic-ai/mcpb": "^2.1.2",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "^9.25.1",
    "@openai/agents": "^0.1.9",
    "@playwright/test": "^1.58.2",
    "@types/cookie-parser": "^1.4.10",
    "@types/cors": "^2.8.19",
    "@types/eslint__js": "^8.42.3",
    "@types/express": "^5.0.3",
    "@types/fast-levenshtein": "^0.0.1",
    "@types/node": "^22.15.3",
    "@types/supertest": "^6.0.3",
    "@typescript-eslint/eslint-plugin": "^8.31.1",
    "@typescript-eslint/parser": "^8.31.1",
    "@vitest/coverage-v8": "^3.1.3",
    "esbuild": "^0.25.5",
    "eslint": "^9.25.1",
    "eslint-config-prettier": "^10.1.2",
    "eslint-plugin-prettier": "^5.2.6",
    "eslint-plugin-simple-import-sort": "^12.1.1",
    "jsdom": "^29.1.1",
    "npm-run-all": "^4.1.5",
    "openai": "^5.23.2",
    "prettier": "^3.5.3",
    "supertest": "^7.1.4",
    "tsx": "^4.21.0",
    "typescript": "^5.8.3",
    "typescript-eslint": "^8.31.1",
    "vite-plugin-singlefile": "^2.3.3",
    "vitest": "^3.1.3"
  },
  "engines": {
    "node": ">=22.7.5"
  }
}
